<template >
    <div class='row'>
		<fieldset>
			<legend>Atuação do orientador na SIAC</legend>
			<div class="row centered">
				<table class="table-responsive highlight striped ">
					<col width="5%">
					<col width="30%">
					<col width="20%">
					<col width="20%">
					<col width="20%">
					<col width="5%">
					<thead>
						<th></th>
						<th>Tipo de Atuação</th>
						<th>Quantidade</th>
						<th>PDF</th>
						<th>Nota</th>
						<th></th>
					</thead>
					<tbody>
						<tr v-for="(atuacao, index) in project.curriculo.atuacoes" v-if="atuacao.atuacao.tipo == 'SIAC'">
							<td></td>
							<td>{{atuacao.atuacao['nome']}}</td>
							<td>{{atuacao['quantidade']}}</td>
							<td v-if="atuacao['pdf']">
								<a :href="'/curriculos/atuacoes/pdf/' + atuacao['id']" class="btn" target='_blank'>
									<i class="material-icons left">assignment_returned</i>Visualizar PDF
								</a>
							</td>
							<td v-else></td>
							<td>
								<template v-for='avaliacao in avaliacao_orient' v-if="atuacao.atuacao['nome'] == avaliacao.nome">
									<select class="browser-default select_sec siac" v-model='avaliacao.nota' @change="calcularNota()">
										<option disabled selected value=-1>Selecione uma nota</option>
										<option>0.0</option>
										<option>{{avaliacao.pontos}}</option>
									</select>
								</template>
							</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col s12" v-if="true">
				<div class="row">
					<span style="font-size: 20px;">Nota Final: {{notaFinalOrient}}</span>
				</div>
			</div>
		</fieldset>

        <fieldset>
            <legend>Trabalhos do edital anterior da SIAC</legend>
            <div class="col s12" v-if="message == undefined">
                <base-collapsible
                    v-for="(trabalho, index) in trabalhos"
                    :key="index">
                    <span slot='collapsible-header'>
                        {{trabalho.titulo}}
                        <i class="large material-icons">expand_more</i>
                    </span>
                    <div class="row" slot='collapsible-body'>
                       <div class="col s12 detalhes">
                           <span>Autores:</span>
                           <ol>
                               <li
                               v-for="(autor,index) in stringToArray(trabalho.autores)"
                                :key="index">
                                        {{autor}}
                                </li>
                           </ol>


                       </div>
                       <div class="col s12 detalhes">
                           <span>Orientadores:</span>
                           <ol>
                               <li
                                v-for="(orientador,index) in stringToArray(trabalho.orientadores)"
                                :key="index">
                                        {{orientador}}
                                </li>
                           </ol>
                       </div>
                        <div class="col s12 detalhes">
                           Modalidade de Participação: {{trabalho.modalidade_participacao}}
                       </div>
                        <div class="col s12 detalhes">
                           Área de Conhecimento: {{trabalho.area_conhecimento}}
                       </div>
                        <div class="col s12 detalhes">
                           Área Temática: {{trabalho.area_tematica}}
                       </div>
                        <div class="col s12 detalhes">
                           Modalidade de Apresentação: {{trabalho.modalidade_apresentacao}}
                       </div>
                        <div class="col s12 detalhes">
                           Apresentado: {{trabalho.trabalho_apresentado == "P"?"Sim":"Não"}}
                        </div>
                        <div class="col s8 detalhes">
                            <label>Avaliação do Trabalho:</label>
                            <select class="browser-default"
                                v-model="avaliacao_siac[index].trabalho.nota"
                                @change="onChangeSelect(trabalho,index)">
                                <option disabled selected>Selecione um item....</option>
                                <option
                                    v-for="(item, j) in items"
                                    :key="j"
                                    :value="item"

                                >
                                    {{item.nome}}
                                </option>
                            </select>

                        </div>
                        <div class="col s2 detalhes">
                            <span style="font-size: 18px">Nota:<br/>{{getNota(avaliacao_siac[index].trabalho)}}</span>
                        </div>
                    </div>
                </base-collapsible>
                <div class="row">
                    <span style="font-size: 20px;">Nota Final: {{nota_final}}</span>
                </div>
            </div>
            <div class="col s12" v-else>
                <div class= "card-panel amber lighten-3">
                    <span>
                        {{message}}
                    </span>
                </div>
            </div>
        </fieldset> <br>
		<div class="row">
			<div class="col s12">
				<button
					class="btn waves-effect waves-light"
					type="button"
					name="action"
					@click.prevent="onClick()">
					Avaliar
					<i class="material-icons right">send</i>
				</button>
			</div>
		</div>

    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import BaseCollapsible from './BaseCollapsible.vue';
const GRUPO = 5;
const ITEM_URL = `/api/grupos/siac/${GRUPO}`;
export default {
  props: ['itens_siac_orientador', 'nota_max_siac_orient'],
  components: { BaseCollapsible },
    name: 'AvaliacaoSiac',
    data(){
       return{
            items:[],
            trabalhos: [],
            message : undefined,
            avaliacao_siac: [],
			avaliacao_orient: [],
            nota_final: 0,
			notaMax: 0,
			notaFinalOrient: 0.0,
			itensSiacOrientador: JSON.parse(this.itens_siac_orientador),
        };
    },
    computed:{
        ...mapState(['project'])
    },
    watch:{
        trabalhos:function(newValue,oldValue){
            if(newValue.length)
                this.setAvaliacaoSiac();
        }
    },
    methods:{
        ...mapActions(['setAvaliacaoSiac']),
        getNota(trabalho){
            try {
				if (trabalho.nota.pontos === null)
					return null;
                return Number(trabalho.nota.pontos);
            } catch (error) {
                return 0;
            }

        },
       _createAvaliacaoSiac(){
           const length = this.trabalhos.length;
           let avaliacoes = [];
           for(let i = 0; i< length; i++){
               avaliacoes[i] = {"trabalho":{ "nota": { "peso": 1, "pontos": null}}}
           }
           this.$set(this,"avaliacao_siac",avaliacoes);
           this.setNotaFinal();
       },
        async setAvaliacaoSiac(){
            let avaliacoes = [];
            try {
                avaliacoes = JSON.parse(this.project.avaliacao.avaliacao_siac);
				if (!avaliacoes || !avaliacoes.length)
                    this._createAvaliacaoSiac();
				else {
					for(let i = 0; i< avaliacoes.length; i++){
						const item = avaliacoes[i];
						if(!item){
							avaliacoes[i] = {"trabalho":{ "nota": { "peso": 1, "pontos": null}}}
						}
					}
					this.$set(this,"avaliacao_siac",avaliacoes);
					this.setNotaFinal();
				}
            } catch (error) {
                if(avaliacoes == null)
                    this._createAvaliacaoSiac();
                else
                    console.error(error);
            }

        },
		async setAvaliacaoOrient() {
			var avaliacoes = JSON.parse(this.project.avaliacao.avaliacao_siac_orient);
			if (!avaliacoes) {
				var itens = this.itensSiacOrientador,
					atuacoes = this.project.curriculo.atuacoes,
					tamItens = itens.length,
					tamAtu = atuacoes.length;

				avaliacoes = [];
				for (var i = 0; i < tamAtu; i++) {
					for (var j = 0; j < tamItens; j++)
						if (atuacoes[i].atuacao.tipo == 'SIAC' && atuacoes[i].atuacao['nome'] == itens[j].nome) {
							itens[j].nota = -1;
							itens[j].notaMax = this.nota_max_siac_orient;
							avaliacoes.push(itens[j]);
							break;
						}
				}
			}
			this.avaliacao_orient = avaliacoes;
			this.calcularNota();
		},
        async onClick(){
            try {
                const {data,status}= await this.$http.post('/api/avaliacaoSiac',{
                    "avaliacaoSiac" : this.avaliacao_siac,
					"avaliacaoOrient" : this.avaliacao_orient,
                    "id":this.project.avaliacao.id
                });
                showMsg(data,status);

            } catch ({body,status}) {
                showMsg(body,status);
            }
        },
         setNotaFinal(){
            let notaFinal = 0;
            let qtdTrabalhos = this.trabalhos.length ? this.trabalhos.length : 0;
            for(let i = 0; i< this.avaliacao_siac.length ; i++){
                const item = this.avaliacao_siac[i].trabalho;
                notaFinal = Number(notaFinal) + (Number(item.nota.pontos));
            }
            if(qtdTrabalhos == 0)
                notaFinal = 0;
            else
                notaFinal = (notaFinal / qtdTrabalhos)
            this.$set(this,'nota_final',notaFinal.toFixed(2));

        },
        stringToArray(str){
			if (str)
				return str.split(",");
			return null;
        },
        async onChangeSelect(trabalho, index){
            let nota = this.avaliacao_siac[index].trabalho.nota;
            trabalho.nota = nota;
            this.avaliacao_siac[index] = {trabalho};
            this.$set(this,"avaliacao_siac",this.avaliacao_siac);
            this.setNotaFinal();
        },
		async getNotaMax() {
            try {
                let { data } = await this.$http.get("/api/nova_avaliacao/notaMax/7");
                return data[0].nota_max;
            } catch (error) {
                console.log(error);
            }
        },
        async getTrabalhosByCpf(){
            try {
                let cpf = this.project.curriculo.usuario.cpf;
                let tipo = this.project.curriculo.edital.siac_anterior;
                let avaliacaoId = this.project.avaliacao.id;

                let {data} = await this.$http.get(`/api/siac/${cpf}/${tipo}/${avaliacaoId}`);
                this.$set(this,'message',data['message']);
                let result = data['result'];
                this.$set(this,'trabalhos',result);

            } catch (error) {
                console.error(error);
            }

        },
        async getItems(){
            try {
                let {data} = await this.$http.get(ITEM_URL);
                this.$set(this,'items',data);

            } catch (error) {
                console.log(error);
            }
        },
		calcularNota() {
			var selects = document.getElementsByClassName('siac'),
			    i = selects.length,
				soma = 0,
				max = Number(this.avaliacao_orient[0]? this.avaliacao_orient[0].notaMax : this.nota_max_siac_orient).toFixed(1),
				valor;

			while (--i >= 0) {
				valor = Number(selects[i].value);
				this.avaliacao_orient[i].nota = selects[i].value;
				if (valor >= 0)
					soma += valor;
			}


			if (soma > max)
				this.notaFinalOrient = max;
			else
				this.notaFinalOrient = soma.toFixed(1);
		},
    },
    beforeMount(){
        this.setAvaliacaoSiac();
		this.setAvaliacaoOrient();
    },
    async mounted(){
        await this.getTrabalhosByCpf();
        await this.getItems();

		this.calcularNota();

    },
    updated(){
        this.setNotaFinal();
    },
	created(){

	}
}

</script>
<style scoped>
    .detalhes{
        padding-bottom: 5px;
        padding-top: 5px;
    }
</style>